module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_01-0ca19bc115475a73e6d9a2a3b729505c.webp";